import styled from "styled-components";
import { Button, Segmented } from "antd";
import tickIcon from "@/assets/tickIcon.png";
import { media } from "@/theme/breakpoints";

export const MainLayout = styled.div`
  margin-top: 2rem;
`;

export const StyledHeading = styled.h2`
  margin: 0;
  color: #171725;
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-weight: 600;
`;

export const StyledSubHeading = styled.p`
  margin: 8px 0 0;
  color: #585858;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  line-height: 1.5;
`;

export const BillingToggle = styled(Segmented)`
  margin: 24px 0;
  width: fit-content;
`;

export const PlanGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  ${media.downTablet`
    grid-template-columns: 1fr;
  `}
`;

export const PlanCard = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ $featured }) => ($featured ? "#ed6928" : "#dae0e7")};
  background: #fafafa;
  padding: 20px;
  box-sizing: border-box;
  ${({ $featured }) =>
    $featured
      ? `
    border-top: 8px solid #ed6928;
  `
      : ""}
`;

export const PlanTitle = styled.h3`
  margin: 0;
  color: #171725;
  font-family: Poppins, sans-serif;
  font-size: 22px;
  font-weight: 600;
`;

export const PlanDescription = styled.p`
  margin: 8px 0 0;
  color: #585858;
  font-size: 13px;
  line-height: 1.4;
`;

export const PriceLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin: 16px 0 8px;
`;

export const StyledPrice = styled.span`
  color: #171725;
  font-family: Poppins, sans-serif;
  font-size: 32px;
  font-weight: 600;
`;

export const StyledCategory = styled.span`
  color: #585858;
  font-size: 14px;
`;

export const TrialNote = styled.p`
  margin: 0 0 16px;
  color: #585858;
  font-size: 12px;
`;

export const FeatureList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const FeatureItem = styled.li`
  position: relative;
  padding-left: 24px;
  margin-bottom: 8px;
  color: #585858;
  font-size: 13px;
  line-height: 1.4;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    width: 16px;
    height: 16px;
    background: url(${tickIcon}) center / contain no-repeat;
  }
`;

export const PlanButton = styled(Button)`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  background: #ed6928 !important;
  border-color: #ed6928 !important;
  color: #fff !important;
  font-weight: 600;
  margin-top: 8px;

  &:hover,
  &:focus {
    background: #d85a1f !important;
    border-color: #d85a1f !important;
    color: #fff !important;
  }
`;

export const AlertBanner = styled.div`
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 6px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  color: #874d00;
  font-size: 13px;
`;
